/* Per-visitor countdown (urgency banner Timer mode = Per visitor).
   Markup: an element with data-ygh-visitor, data-hours="24" and data-key="<offer key>", holding
   [data-cd-d] [data-cd-h] [data-cd-m] [data-cd-s]. The first time a visitor sees it, the moment is stored in a
   cookie (ygh_vt_<key>, 90 days, also kept in localStorage); the timer then counts down N hours from that moment.
   It never restarts: at zero it stays 00 and gets the is-ended class (the urgency banner's ended state hangs on it).
   With no [data-cd-d] the days are added to the hours, same as ygh-countdown.js. */
(function () {
  if (window.__yghVisitor) { window.__yghVisitor(); return; }
  function pad(n) { return String(Math.max(0, n)).padStart(2, '0'); }
  function set(root, sel, v) { var e = root.querySelector(sel); if (e) e.textContent = v; }
  function readCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&') + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function firstSeen(key) {
    var name = 'ygh_vt_' + key.replace(/[^a-z0-9_-]/gi, '_');
    var v = parseInt(readCookie(name), 10);
    if (!v) { try { v = parseInt(localStorage.getItem(name), 10); } catch (e) {} }
    if (!v || v > Date.now()) {
      v = Date.now();
      try { localStorage.setItem(name, String(v)); } catch (e) {}
    }
    document.cookie = name + '=' + v + '; path=/; max-age=' + (90 * 86400) + '; SameSite=Lax';
    return v;
  }
  var timers = [];
  function scan() {
    document.querySelectorAll('[data-ygh-visitor]:not([data-ygh-visitor-on])').forEach(function (el) {
      el.setAttribute('data-ygh-visitor-on', '');
      var hours = parseFloat(el.getAttribute('data-hours')) || 24;
      var key = el.getAttribute('data-key') || location.pathname;
      timers.push({ el: el, end: firstSeen(key) + hours * 3600000 });
    });
  }
  function tick() {
    var now = Date.now();
    timers.forEach(function (t) {
      var diff = Math.max(0, t.end - now);
      var hasD = !!t.el.querySelector('[data-cd-d]');
      set(t.el, '[data-cd-d]', pad(Math.floor(diff / 86400000)));
      set(t.el, '[data-cd-h]', pad(hasD ? Math.floor(diff % 86400000 / 3600000) : Math.floor(diff / 3600000)));
      set(t.el, '[data-cd-m]', pad(Math.floor(diff % 3600000 / 60000)));
      set(t.el, '[data-cd-s]', pad(Math.floor(diff % 60000 / 1000)));
      var ended = diff <= 0;
      if (t.el.classList.contains('is-ended') !== ended) t.el.classList.toggle('is-ended', ended);
    });
  }
  window.__yghVisitor = function () { scan(); tick(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', window.__yghVisitor);
  else window.__yghVisitor();
  setInterval(tick, 1000);
})();
